const recommendedRules = {
  "functype/no-let": "error",
  "functype/prefer-option": "warn",
  "functype/prefer-either": "warn",
  "functype/prefer-try": "warn",
  "functype/prefer-fold": "warn",
  "functype/prefer-map": "warn",
  "functype/prefer-flatmap": "warn",
  "functype/prefer-functype-map": "warn",
  "functype/prefer-functype-set": "warn",
  "functype/no-imperative-loops": "warn",
  "functype/prefer-do-notation": "warn",
  "functype/no-get-unsafe": "off",
  "functype/prefer-list": "off",
}

export default recommendedRules
